// @cortex/sdk-chat-client: the typed client of the chat's backend (ADR 0060), generated from the SDK's own contract
// (../server/openapi.json, written by the server's `openapi:write`). Any UI uses it — the SDK's React views, a custom
// page, the chat service's store — against any host that mounts the chat, at the base URL the host mounts it under.
import createClient, { type Client, type Middleware } from 'openapi-fetch';
import type { paths } from './generated/schema.ts';

export type { components, paths } from './generated/schema.ts';

/** Where the routes are and how to authenticate. */
export interface ChatClientOptions {
  /** Where the host mounts the chat's routes (`''`-relative in a browser on the host's origin). */
  baseUrl: string;
  /** A bearer token for each call (the host's session); null or undefined sends none. */
  token: () => Promise<string | null | undefined> | string | null | undefined;
  fetch?: typeof fetch;
}

export type ChatClient = Client<paths>;

/** The typed client: `GET`, `POST`, … over the chat's paths, with the host's bearer on every call. */
export function createChatClient({ baseUrl, token, fetch: f }: ChatClientOptions): ChatClient {
  const client = createClient<paths>({ baseUrl, ...(f ? { fetch: f } : {}) });
  const auth: Middleware = {
    async onRequest({ request }) {
      const t = await token();
      if (t) request.headers.set('authorization', `Bearer ${t}`);
      return request;
    },
  };
  client.use(auth);
  return client;
}
